import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'schools.resources.thankyou.heading',
		defaultMessage: 'Thank you, teachers.{mobileBreak} We see you.',
		description: 'Calm Schools Thank You heading text',
	},
	body: {
		id: 'schools.resources.thankyou.body.updated',
		defaultMessage: 'Thank you for supporting the minds and hearts of the next generation.',
		description: 'Calm Schools Resources Thank You body text',
	},
	cta: {
		id: 'schools.navHeader.cta.tryFree',
		defaultMessage: 'Try Calm for Free',
		description: 'Calm Schools Thank You call to action text',
	},
});
